import React from 'react';
import type { VisibaCortexHeadLessStackProps } from './headless_stack.component';
import { HeadLessStack } from './headless_stack.component';
import { unwrapFragment } from './unwrap_fragment';

export interface VisibaCortexVStackProps extends Partial<Omit<VisibaCortexHeadLessStackProps, 'axis'>> {
	className?: string;
}

/**
 * # cortex:react-ui:VStack
 * Deprecated: Use Cellula components instead
 */

export const VStack: React.FC<VisibaCortexVStackProps> = function VStack({ className, spacing = 0, fluid = true, children }) {
	const flatten = unwrapFragment(children);

	return (
		<HeadLessStack spacing={spacing} axis={'Vertical'} fluid={fluid}>
			{({ childClassName, parentClassName }) => (
				<div className={`${className ?? ''} ${parentClassName}`.trim()}>
					{flatten.map((child) => {
						if (child === null) return child;

						return React.cloneElement(child, {
							...child.props,
							className: `${child.props.className ?? ''} ${childClassName}`.trim(),
						});
					})}
				</div>
			)}
		</HeadLessStack>
	);
};
